//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generalDropDown } from '@tidal/styles-icons';

export default {
    data() {
        return {
            isExpanded: false,
            /** @type {Function?} */
            unregisterAfterEachHook: null,
        };
    },
    computed: {
        icons() {
            return {
                generalDropDown,
            };
        },
    },
    mounted() {
        this.$router.afterEach(() => {
            this.closeDropDown();
        });
    },
    beforeDestroy() {
        this.removeDropdownListener();

        if (this.unregisterAfterEachHook) {
            this.unregisterAfterEachHook();
            this.unregisterAfterEachHook = null;
        }
    },
    methods: {
        closeDropDown() {
            if (this.isExpanded) {
                this.toggleDropDown();
            }
        },
        toggleDropDown() {
            this.isExpanded = !this.isExpanded;

            if (this.isExpanded) {
                this.addDropdownListener();
            } else {
                this.removeDropdownListener();
            }

            this.onDropdownVisibilityChanged();
        },
        onDropdownVisibilityChanged() {
            this.$emit('visibility-change', this.isExpanded);
        },
        /** @param {MouseEvent} event The event */
        dropdownListener(event) {
            const menuElement = /** @type HTMLElement */(this.$refs.menu);
            if (!menuElement.contains(/** @type HTMLElement */(event.target))) {
                this.toggleDropDown();
            }
        },
        addDropdownListener() {
            document.addEventListener('click', this.dropdownListener);
        },
        removeDropdownListener() {
            document.removeEventListener('click', this.dropdownListener);
        },
    },
};
